module.exports = __webpack_public_path__ + "img/header.ec4bbcc4.png";